/* AnimationType reference:
- fade: element fades in from opacity 0 to opacity 1
- fade-scale-down: element fades in (0 → 1) while scaling up from a smaller size
- fade-scale-up: element fades in (0 → 1) while scaling down from a larger size

Additional config:
- offset: scroll distance (in px) before the animation is triggered.
  Example: offset: 250 → the element will start animating when it is 250px
  away from entering the viewport.
*/

export type AnimationType = "fade" | "fade-scale-down" | "fade-scale-up";

export interface BrandConfig {
  classMap: Record<string, AnimationType>;
  offset?: number;
}

// Map of brand aliases to their canonical webcodes.
// This is used as a fallback when 'data-webcode' is not available (e.g., in local environments).
export const aliasBrandMap: Record<string, string> = {
  bttb: "BTTB_ES",
  bttb_pt: "BTTB_PT",
  halcon: "HALCON",
};

const bttbConfig: BrandConfig = {
  classMap: {
    "dsc-co-hero": "fade-scale-up",
    "section-mainHeading": "fade",
    "section-sliderCoop": "fade-scale-down",
    "section-bannerMarketing": "fade",
    "section-productCards": "fade",
    "section-bannerAssistance": "fade",
    "section-bannerInterests": "fade",
    "section-sliderCoop2": "fade-scale-down",
    "section-popularToursV2": "fade",
    "section-bannerAgencies": "fade-scale-down",
    "section-dinamicDestinations": "fade",
    "section-blogV2": "fade",
    "section-newsletter": "fade",
    "dsc-co-footerContainer": "fade",
  },
  offset: 250,
};

export const animationsConfig: Record<string, BrandConfig> = {
  BTTB_ES: bttbConfig,
  BTTB_PT: bttbConfig,
  HALCON: {
    classMap: {
      "section-mainHeading": "fade",
      "section-sliderCoop": "fade-scale-down",
      "section-bannerMarketing": "fade",
      "section-bannerBento": "fade",
      "section-sliderCoop2": "fade-scale-down",
      "section-popularTours": "fade",
      "section-bannerCoMarketing": "fade",
      "section-bannerProduct": "fade",
      "section-dinamicDestinations": "fade",
      "section-valueProposition": "fade",
      "section-blog": "fade",
      "dsc-co-footerContainer": "fade",
    },
    offset: 250,
  },
};

export default animationsConfig;
